import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetJobRequestByIdQuery } from "../../../redux/Hire/jobRequestApi";
import Layout from "../../../shared/components/LayoutV2";
import JobBreadcrumbs from "../../JobRequest/JobBreadcrumbs";
import AddNewCandidateForm from "./AddNewCandidateForm";

type Props = {};

const NewCandidateContainer = (props: Props) => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const jobId = params.get("jobId");

  const { data: jobReqData } = useGetJobRequestByIdQuery(
    {
      jobRequestId: Number(jobId) || 0,
    },
    {
      skip: !jobId,
    },
  );

  const closeForm = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Layout
      header={
        <JobBreadcrumbs
          paths={[
            {
              label: jobReqData?.data?.title || "Job Request",
              to: `/job-request/${jobId}`,
            },
            { label: "New Candidate", to: "/candidates/new" },
          ]}
        />
      }
      body={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "300px",
          }}
        >
          <AddNewCandidateForm
            clientName={jobReqData?.data?.client || ""}
            closeForm={closeForm}
            jobId={jobId || ""}
            jobTitle={jobReqData?.data?.title || ""}
            jobVersion={jobReqData?.data?.version || 0}
            workableInternalCode={jobReqData?.data?.workableInternalCode || ""}
            stages={jobReqData?.data?.states || []}
          />
        </div>
      }
    />
  );
};

export default NewCandidateContainer;
